/**
 * jQuery.textareaCounter
 * Version 1.0
 * Copyright (c) 2011 c.bavota - http://bavotasan.com
 * Dual licensed under MIT and GPL.
 * Date: 10/20/2011
**/
/*
* ¡Modified since we are not creating dom els!
* ¡Modified for Char not Word Counts!
*/
(function($){
	$.fn.textareaCounter = function(options) {
		// setting the defaults
		// $("textarea").textareaCounter({ limit: 100 });
		var defaults = {
			limit: 100
		};
		var options = $.extend(defaults, options);

		// and the plugin begins
		return this.each(function() {
			var obj, text, wordcount, limit, limited;

			obj = $(this);
			obj.data('counter', obj.next('.wordCount').find('.count'));

			limit = obj.data('limit') || options.limit;

			obj.on('keyup.textareaCounter', function() {

				text = obj.val();
				wordcount = limit - text.length;

				if(wordcount <= 0) {
					obj.data('counter').text(0);
					$(this).val(text.substring(0,limit));
				} else {
					obj.data('counter').text(addCommas(wordcount));
				}

			});

			obj.on('paste.textareaCounter', function() {
				obj.trigger('keyup.textareaCounter');
			});

			obj.trigger('keyup.textareaCounter');
		});
	};
})(jQuery);
